import { Button, Stack, Text } from '@mantine/core';
import { IconArmchair } from '@tabler/icons-react';
import { HOST_SEAT_ACTION_HINT, HOST_SEAT_ACTION_LABEL } from '@creativitas/shared';

/**
 * Ведущий занимает место за собственным столом.
 *
 * Кнопка идёт вместе с пояснением, а не одна: без него действие читалось как
 * отказ от роли ведущего, и садиться за свой стол никто не решался. Один
 * компонент на оба места — в шапке партии и в комнате ожидания, — чтобы
 * подпись и пояснение не разошлись.
 */
export function HostSeatAction({
  busy,
  onClick,
  variant = 'light',
}: {
  busy: boolean;
  onClick: () => void;
  variant?: 'light' | 'subtle';
}) {
  return (
    <Stack gap={4} align="flex-start" data-testid="host-seat-action">
      <Button
        variant={variant}
        leftSection={<IconArmchair size={17} />}
        loading={busy}
        onClick={onClick}
      >
        {HOST_SEAT_ACTION_LABEL}
      </Button>
      <Text size="xs" c="var(--text-muted)" maw={260}>
        {HOST_SEAT_ACTION_HINT}
      </Text>
    </Stack>
  );
}
